export function parseErrorsForAssigments(error) {
  const _error =
    error.formErrors && error.formErrors._error
      ? error.formErrors._error
      : `${Object.keys(error.formErrors).toString()} invalid`;
  return _error;
}
